<template>
  <div class="ksxxcx">
    <Header title="考试信息查询" type="0" route="/new/Home"></Header>
    <div class="header-cx">
      <div class="xnxq" @click="xnxqFuct">
        <span>{{ xnxqName }}</span>
        <img src="@/assets/images/aroow.png" alt="">
      </div>
      <div class="xnxq" @click="xqlbFuct">
        <span v-if="xqlbName">{{xqlbName}}</span>
        <span v-else style="color:#999">请选择学期类别</span>
        <img src="@/assets/images/aroow.png" alt="">
      </div>
    </div>
    <div class="lc-list" v-for="(i,y) in List" :key="y">
      <div class="list-li">
        <p>{{i.kssj}}</p>
        <div class="li-jbxx">
          <div class="jbxx-js">
            <span>{{i.kskcmc}}</span>
            <p>授课教师：{{i.jsxm}}</p>
          </div>
          <div class="jbxx-ccxx">
            <p><img src="@/assets/images/list1.png" alt=""> 主考人员：{{i.xm}}</p>
            <p><img src="@/assets/images/list2.png" alt=""> 考试场地：{{i.kcmc}}</p>
            <p><img src="@/assets/images/list3.png" alt=""> 考试场次：{{i.ksccmc}}</p>
          </div>
        </div>
      </div>
      <!-- <div class="list-li">
        <p>2022-02-21 18:00:00-20:00:00</p>
        <div class="li-jbxx">
          <div class="jbxx-js">
            <span>复变函数</span>
            <p>授课教师：吴秋莹</p>
          </div>
          <div class="jbxx-ccxx">
            <p><img src="@/assets/images/list1.png" alt=""> 主考人员：吴秋莹</p>
            <p><img src="@/assets/images/list2.png" alt=""> 考试场地：电信楼多媒体423</p>
            <p><img src="@/assets/images/list3.png" alt=""> 考试场次：2024-2025-2期末考试</p>
          </div>
        </div>
      </div> -->
    </div>
    <van-popup class="qzPicker" v-model="showXnxq" round position="bottom">
      <van-picker
        show-toolbar
        title="学年学期"
        :columns="columns"
        @cancel="showXnxq = false"
        @confirm="onXnxqConfirm"
      />
    </van-popup>
    <van-popup class="qzPicker" v-model="showXqlb" round position="bottom">
      <van-picker
        show-toolbar
        title="学期类别"
        :columns="xqlbList"
        @cancel="showXqlb = false"
        @confirm="onXqlbConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default{
  data(){
    return{
      showXnxq:false,
      xnxqName:'',
      xnxqVal:'',
      columns:[],
      showXqlb:false,
      xqlbName:'',
      xqlbVal:'',
      xqlbList:[],
      List:[],
    }
  },
  created(){
    this.getData()
  },
  methods:{
    async getData(){
      const res = await Api.getKsxxXnxq()
      this.columns = res.xnxq01List.map(i=>{
        if(i.isdqxq === "1"){
          this.xnxqVal = i.xnxq01id
          this.xnxqName = i.xqmc
          this.$nextTick(()=>{
            this.getSerachData()
          })
        }
        return {
          text:i.xqmc,
          value:i.xnxq01id
        }
      })
      this.columns.unshift({text:'全部',value:''})
      const res1 = await Api.getKsxxXqlb()
      this.xqlbList = res1.data.map(i=>{
        return {
          text:i.dmmc,
          value:i.dm
        }
      })
      this.xqlbList.unshift({text:'全部',value:''})
    },
    async getSerachData(){
      const res = await Api.getKsapcxQuery({
        xnxqid:this.xnxqVal,
        xqlb:this.xqlbVal
      })
      this.List = res.data
    },
    xqlbFuct(){
      this.showXqlb = true
    },
    onXqlbConfirm(val){
      this.xqlbName = val.text
      this.xqlbVal = val.value
      this.showXqlb = false
      this.getSerachData()
    },
    xnxqFuct(){
      this.showXnxq = true
    },
    onXnxqConfirm(val){
      this.xnxqName = val.text
      this.xnxqVal = val.value
      this.showXnxq = false
      this.getSerachData()
    },
  }
}
</script>
<style lang="less" scoped>
.ksxxcx{
  width: 100%;
  height: calc(100vh - 0.63rem);
  overflow-y: scroll;
  background: #f0f0f2;
  padding:0.63rem 0.88rem;
  box-sizing: border-box;
  .header-cx{
    display: flex;
    justify-content: space-between;
    .xnxq{
      width: 48.4%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:0.56rem 0.63rem;
      box-sizing: border-box;
      border-radius: 8px;
      background: #fff;
      span{
        color:#333;
        font-size: 0.9rem;
      }
    }
  }
  .lc-list{
    width: 100%;
    background: #fff;
    border-radius: 0.5rem;
    margin-top:0.63rem;
    padding:0.9rem;
    box-sizing: border-box;
    .list-li{
      border-left:1px dashed rgba(116,105,248,0.2);
      padding:0 0 0.94rem 0.9rem;
      box-sizing: border-box;
      position: relative;
      p{
        font-size: 0.88rem;
        line-height: 1;
      }
      .li-jbxx{
        margin-top:0.63rem;
        background-image:linear-gradient(90deg,rgba(116,105,248,0.06) 0%,rgba(116,105,248,0.02) 100%);
        border-radius: 0.38rem;
        padding:0.6rem 0.75rem;
        box-sizing: border-box;
        .jbxx-js{
          border-bottom:1px dashed rgba(116,105,248,0.2);
          padding:0.4rem 0;
          box-sizing: border-box;
          span{
            color:#333;
            font-weight: 600;
            font-size: 0.9rem;
            line-height: 1;
            display: block;
            margin-bottom:0.6rem;
          }
          p{
            color: #666;
            font-size: 0.75rem;
            line-height: 1;
            margin-bottom:0.4rem;
          }
        }
        .jbxx-ccxx{
          padding:0.4rem 0;
          box-sizing: border-box;
          img{margin-right:0.4rem}
          p{
            color:#837fb1;
            font-size: 0.81rem;
            margin-top: 0.4rem;
            display: flex;
          }
        }
      }
    }
    .list-li:last-child{
      padding-bottom: 0;
    }
    .list-li::before{
      content: "";
      width: 0.88rem;
      height: 0.88rem;
      background: rgba(116,105,248,0.2);
      border-radius: 50%;
      position: absolute;
      top:0;
      left:-0.5rem;
    }
    .list-li::after{
      content: "";
      width: 0.5rem;
      height: 0.5rem;
      background: rgba(116,105,248,1);
      border-radius: 50%;
      position: absolute;
      top:0.18rem;
      left:-0.312rem;
      z-index: 10;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/ksxxcx/index.vue